// src/features/Deliverable/Deliverableslice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getDeliverables,
  addDeliverable,
  updateDeliverable,
  deleteDeliverable,
  getDeliverableHistoryById,
} from "./deliverableApi";

// Thunks
export const fetchDeliverables = createAsyncThunk(
  "Deliverables/fetchDeliverables",
  async (paramsOptions) => {
    const response = await getDeliverables(paramsOptions);
    return { data: response.data, pagination: response.pagination };
  }
);

export const fetchDeliverableHistoryById = createAsyncThunk(
  "projects/fetchDeliverableHistoryById",
  async (paramsOptions) => {
    const response = await getDeliverableHistoryById(paramsOptions);
    return { data: response.data, pagination: response.pagination };
  }
);

export const createDeliverable = createAsyncThunk(
  "Deliverables/createDeliverable",
  async (formData) => {
    const response = await addDeliverable(formData); 
    return response;
  }
);

export const updateDeliverableData = createAsyncThunk(
  "Deliverables/updateDeliverable",
  async (formData) => {
    const response = await updateDeliverable(formData);
    return response;
  }
);

export const deleteDeliverableById = createAsyncThunk(
  "Deliverables/deleteDeliverable",
  async (id) => {
    const response = await deleteDeliverable(id);
    return response;
  }
);

const Deliverableslice = createSlice({
  name: "Deliverables",
  initialState: {
    deliverables: [],
    deliverableHistory: [],
    pagination: {},
    deliverableHistoryPagination: {},
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDeliverables.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDeliverables.fulfilled, (state, action) => {
        state.loading = false;
        const { data, pagination } = action.payload || {};
        state.deliverables = data;
        state.pagination = pagination;
      })
      .addCase(fetchDeliverableHistoryById.fulfilled, (state, action) => {
        state.loading = false;
        const { data, pagination } = action.payload || {};
        state.deliverableHistory = data;
        state.deliverableHistoryPagination = pagination;
      })
      .addCase(createDeliverable.fulfilled, (state, action) => {
        state.deliverables.push(action.payload.data);
      })
      .addCase(updateDeliverableData.fulfilled, (state, action) => {
        const idx = state.deliverables.findIndex((u) => u.id === action.payload.id);
        if (idx !== -1) {
          state.deliverables[idx] = action.payload.data;
        }
      })
      .addCase(deleteDeliverableById.fulfilled, (state, action) => {
        state.deliverables = state.deliverables.filter((u) => u.id !== action.payload.id);
      });
  },
});

export default Deliverableslice.reducer;
